// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../mini-css-extract-plugin/dist/loader.js!../../css-loader/index.js??ref--1-2!../../sass-loader/dist/cjs.js!./vue-simple-accordion.css");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../vue-style-loader/lib/addStylesClient.js").default
var update = add("121bfc29", content, true, {});